import Vue from "vue";
import Router from "vue-router";
import store from "./store";

Vue.use(Router);

// Add this at the beginning of your router code
Vue.config.errorHandler = (err, vm, info) => {
  // Check if the error matches the navigation cancelled error
  if (
    err.name === "NavigationDuplicated" &&
    err.message.includes("Navigating to current location (") &&
    err.message.includes(") is not allowed")
  ) {
    // Silently handle the error by doing nothing
    return;
  }

  // If it's not the navigation cancelled error, handle it as usual
  console.error(err, info);
};

// Define the setRouterBase function
function setRouterBase(organizationName) {
  if (organizationName) {
    router.options.base = `/${organizationName}`;
  }
}

const router = new Router({
  mode: "history",
  base: "",
  routes: [
    

    {
      path: "/",
      name: "login",
      component: () => import("./pages/login.vue"),
      meta: {
        requiresChangedPassword: true,
        title: "Login",
        guest: true,
      },
    },
   
    {
      path: "/requests",
      name: "requests",
      component: () => import("./pages/requests.vue"),
      meta: {
        requiresChangedPassword: true,
        title: "Requests",
        requiresAuth: true,
      },
    },
    {
      path: "/organizations",
      name: "organizations",
      component: () => import("./pages/organizations.vue"),
      meta: {
        requiresChangedPassword: true,
        title: "Organizations",
        requiresAuth: true,
      },
    },
  
    {
      path: "/setups/:type",
      name: "setups",
      component: () => import("./pages/AdminSetups.vue"),
      meta: {
        requiresChangedPassword: true,
        title: "Admin Setups",
        requiresAuth: true,
      },
    },
   
        
    {
      path: "/users",
      name: "users",
      component: () => import("./pages/users.vue"),
      meta: {
        requiresChangedPassword: true,
        title: "Users",
        requiresAuth: true,
      },
    },

    {
      path: "/licenses",
      name: "licenses",
      component: () => import("./pages/licences.vue"),
      meta: {
        requiresChangedPassword: true,
        title: "Licences",
        requiresAuth: true,
      },
    },

    {
      path: "/change-password",
      name: "changePassword",
      component: () => import("./pages/changePassword.vue"),
      meta: {
        requiresChangedPassword: false,
        title: "Change Password",
        requiresAuth: false,
      },
    },

   
  ],
  // make sure the the scroll postion is at the top position
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
});

// Combine your navigation guards into a single beforeEach function
router.beforeEach((to, from, next) => {
  // Check if the route requires authentication
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    if (store.getters.isAuthenticated) {
    
       next();
    } else {
    
      // User is not authenticated, redirect to the login page
      next("/");
    }
  } else if (
    to.matched.some((record) => record.meta.requiresChangedPassword) &&
    store.getters.requiresAuth &&
    !store.getters.isPasswordChanged
  ) {
    // If password change is required, route to the password change page
    next("/change-password");
  
  } else {
    // For other routes, just proceed
  
    next();
  }
});

// Save the route name to the store
router.beforeEach((to, from, next) => {
  store.commit("saveRouteTo", to.name);
  next();
});

// Ensure all pending requests are canceled on route change
router.beforeEach((to, from, next) => {
  store.dispatch("cancelPendingRequests");
  next();
});



// Silence NavigationDuplicated error
const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(() => {});
};

// Attach the setRouterBase function to the Vue prototype
Vue.prototype.$setRouterBase = setRouterBase;

export default router;
